import React, { useState } from "react";

function ClientMaster() {

  const [formData, setFormData] = useState({
    clientName: "",
    email: "",
    mobile: "",
    company: "",
    gst: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    status: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData.clientName)
      tempErrors.clientName = "Client Name is required";

    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }

    if (!formData.mobile) {
      tempErrors.mobile = "Mobile number required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
      tempErrors.mobile = "Enter valid 10 digit number";
    }

    if (!formData.city)
      tempErrors.city = "City is required";

    if (!formData.state)
      tempErrors.state = "State is required";

    if (!formData.status)
      tempErrors.status = "Select Status";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      alert("Client Saved Successfully!");
      console.log(formData);
    }
  };

  const handleReset = () => {
    setFormData({
      clientName: "",
      email: "",
      mobile: "",
      company: "",
      gst: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      status: ""
    });
    setErrors({});
  };

  return (
    <div>
      <h3 className="mb-4 gold-text">Client Master</h3>

      <div className="card p-4">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Client Name */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Client Name *</label>
              <input
                type="text"
                className="form-control"
                name="clientName"
                value={formData.clientName}
                onChange={handleChange}
              />
              {errors.clientName && <small className="text-danger">{errors.clientName}</small>}
            </div>

            {/* Email */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Email *</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </div>

            {/* Mobile */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Mobile *</label>
              <input
                type="text"
                className="form-control"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
            </div>

            {/* Company */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                className="form-control"
                name="company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            {/* GST */}
            <div className="col-md-6 mb-3">
              <label className="form-label">GST Number</label>
              <input
                type="text"
                className="form-control"
                name="gst"
                value={formData.gst}
                onChange={handleChange}
              />
            </div>

            {/* Address */}
            <div className="col-md-12 mb-3">
              <label className="form-label">Address</label>
              <textarea
                className="form-control"
                rows="2"
                name="address"
                value={formData.address}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* City */}
            <div className="col-md-4 mb-3">
              <label className="form-label">City *</label>
              <input
                type="text"
                className="form-control"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
              {errors.city && <small className="text-danger">{errors.city}</small>}
            </div>

            {/* State */}
            <div className="col-md-4 mb-3">
              <label className="form-label">State *</label>
              <input
                type="text"
                className="form-control"
                name="state"
                value={formData.state}
                onChange={handleChange}
              />
              {errors.state && <small className="text-danger">{errors.state}</small>}
            </div>

            {/* Pincode */}
            <div className="col-md-4 mb-3">
              <label className="form-label">Pincode</label>
              <input
                type="text"
                className="form-control"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
              />
            </div>

            {/* Status */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Status *</label>
              <select
                className="form-select"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.status && <small className="text-danger">{errors.status}</small>}
            </div>

          </div>

          {/* Buttons */}
          <div className="text-end">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={handleReset}
            >
              Reset
            </button>
            <button type="submit" className="btn btn-warning">
              Save Client
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default ClientMaster;
